import React, {useState, useEffect, useContext, useRef} from 'react';
import { useTranslate } from 'react-redux-multilingual';
import { SubmitForm, ArticleBarSearch, ItemAbonnementArticle } from "@gull";
import axios from 'axios';
import swal from "sweetalert2";
import { IsAuthContext } from 'app/App';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus,faTimes} from '@fortawesome/free-solid-svg-icons';
import { useForm } from "react-hook-form";

const useLoad = (props, setValue) => {
    const t = useTranslate();
    const [validButton,setValidButton] = useState(false)
    const [datas,setDatas]=useState([])
    const [datasForm,setDatasForm]=useState([])

    useEffect(function () {
        if (props.editArticleId) {
            (async function() {
                setValidButton(true)
                const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/one/"+props.editArticleId
                ).then((response) => {
                    if(!response.data.valid){
                        let interms='';
                        var keys = Object.keys(response.data.errors);
                        for(var i = 0; i < keys.length; i++){
                            interms+=response.data.errors[keys[i]].join(',')+','
                        }
                        interms=interms.split(',')
                        let messageError='';
                        interms.forEach(interm=>messageError+=t(interm)+'. ')
                        messageError=messageError.replace('undefined','');
                        swal.fire(messageError, "", "error");
                    }
                    else{   
                        setDatas(response.data.data)
                        setValue('credit',response.data.data.credit)
                        setValue('abonnement',response.data.data.abonnement)
                    }
                }).catch((error) => {
                    if(error=='end_session') return;
                    swal.fire(t('unknowError'), "", "error");
                })
                setValidButton(false)
            })()
        }
    }, [props.editArticleId])

    // Mise à jour de datasForm pour affichage du formulaire
    useEffect(function () {
        if (datas != null && datas.abonnement_article != null) {
            let datasTemp=[]

            Object.values(datas.abonnement_article).forEach((value) => {
                datasTemp.push({id:value.id,name:value.name,_key:Date.now()+Math.random()})
            });
            setDatasForm(datasTemp)
        }
        else setDatasForm([])

    }, [datas])
    
    return [validButton,setValidButton,datasForm,setDatasForm]
}


const ModalAbonnement = (props) =>{
    const t = useTranslate(); //Traduction
    const { authParam } = useContext(IsAuthContext); //AuthParams

    const { register, formState: { errors }, handleSubmit, setValue } = useForm({
        defaultValues: {
            abonnement_article_id: []
        }
    });
    
    const [apiError,setApiError] = useState(false)
    const [success,setSuccess] = useState(false)

    const [validButton,setValidButton,datasForm,setDatasForm] = useLoad(props, setValue) //useLoad

    const onSubmit = async (data) =>{
        setValidButton(true)
        setSuccess(false)
        setApiError(false)

        let obj = {
            credit: (data.credit=='' || data.credit==null) ? null : data.credit,
            abonnement: (data.abonnement=='' || data.abonnement==null) ? null : data.abonnement,
            abonnement_article_id: datasForm.map(value => value.id),
        }

        const response  = await axios.post(process.env.REACT_APP_API_URL+"api/erp/article/create_or_edit_abonnement/"+props.editArticleId,obj
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach((interm)=>{
                    let finalMessage=interm.split('/!');
                    if(finalMessage.length==2){
                        messageError+=t(finalMessage[0],{name:finalMessage[1]})+'<br/>'
                    }
                    else{
                        messageError+=t(interm)+'<br/>'
                    }
                })
                    messageError=messageError.replace('undefined','');
                    setApiError(messageError)
            }
            else{
                setSuccess(true)
                props.onCloseModal()
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
        setValidButton(false)
        setTimeout(()=>{
            setSuccess(false);
        },1000)            
    }

    const handleChange = (e) => {
        setValue('order',e.target.value.replace(/[^0-9]/g, ''));
    }

    // Ajouter une ligne
    const addLine = () => {
        setDatasForm(prev => [...prev,{_key:Date.now()+Math.random()}])
    }

    // Supprimer une ligne
    const handleRemoveLine = (index) => {
        setDatasForm(prev => 
            prev.filter(line => line._key !== index)
        )
    }

    console.log(datasForm);

    return(<>
        <div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group row">
                    <label>{t('credit')}</label>
                    <div className='col'>
                        <input {...register("credit")} className="form-control" type="number" disabled={validButton} onChange={(e) => handleChange(e)} 
                            onKeyDown={(e) => {
                                if (["e", "E", "+", "-", ".",","].includes(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label>{t('abonnement')}</label>
                    <div className='col'>
                        <input {...register("abonnement")} className="form-control" type="number" disabled={validButton} onChange={(e) => handleChange(e)} 
                            onKeyDown={(e) => {
                                if (["e", "E", "+", "-", ".",","].includes(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <div className='row'>
                        <div>
                            <label>
                                {t('newLine')}:&nbsp;&nbsp;
                            </label>
                            <button
                                type="button"
                                className="btn btn-sm btn-success"
                                onClick={()=>addLine()}
                            >
                                <FontAwesomeIcon icon={faPlus} />
                            </button>
                        </div>
                    </div>
                    <div className='row'>
                        <label>{t('item')}</label>
                        <div className='col'>
                            {
                                (datasForm.length>0) && datasForm.map((value, index)=>{
                                    return (value.id) ?
                                        < ItemAbonnementArticle
                                            key={value._key}
                                            index={value._key}
                                            articleId={value.id}
                                            articleName={value.name}
                                            handleRemoveLine={() => handleRemoveLine(value._key)}
                                            setDatasForm={setDatasForm}
                                        />
                                    :
                                        < ItemAbonnementArticle
                                            key={value._key}
                                            index={value._key}
                                            handleRemoveLine={() => handleRemoveLine(value._key)}
                                            setDatasForm={setDatasForm}
                                        />
                                })
                            }
                        </div>
                    </div>
                </div>
                <SubmitForm validButton={validButton} success={success} error={apiError} />
            </form>
        </div>
    </>)
}

export default ModalAbonnement;